export default {
  namespaced: true,
  state: {
    windowWidth: window.innerWidth,
    // Header.vue
    showMenu: false,
    showOptions: false,
    // Loading Bar
    showLoading: false
  },
  getters: {
    show_options: state => {
      return state.showOptions
    },
    show_menu: state => {
      return state.showMenu
    },
    show_loading: state => {
      return state.showLoading
    }
  },
  mutations: {
    SET_HEADER_OPTION (state, payload) {
      state.showOptions = payload
    },
    TOGGLE_MENU (state, payload) {
      state.showMenu = payload
    },
    TOGGLE_LOADING (state, payload) {
      state.showLoading = payload
    }

  },
  actions: {
    toggleOptions (vuex, payload) {
      vuex.commit('SET_HEADER_OPTION', payload)
    },
    toggleMenu (vuex, payload) {
      vuex.commit('TOGGLE_MENU', payload)
      // TODO Toggle Options if  state.showOptions = true
    },
    toggleLoading (vuex, payload) {
      vuex.commit('TOGGLE_LOADING', payload)
    }
  }
}
